import { render } from "./PostPrepaid.vue?vue&type=template&id=00c2bc16"
import script from "./PostPrepaid.vue?vue&type=script&lang=js"
export * from "./PostPrepaid.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./PostPrepaid.vue?vue&type=style&index=1&id=00c2bc16&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__